import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import RecommendRanking from '../../../../ExecutiveList/parts/RecommendRanking';
import { filterSortIntentTags } from '../../../../../utils/utils';
import Label from "../../../../ExecutiveList/Spreadsheet/parts/Label";

const styles = () => ({
  tagsRoot: {
    marginTop: "10px",
    marginLeft: "-4px",
  },
  tagsContainer: {
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap",
    overflow: "hidden",
    maxHeight: "45px",
  },
  tag: {
    marginRight: "2px",
    padding: "4px",
  },
  ellipsis: {
    marginLeft: "4px",
    color: "#71737B",
    fontSize: "12px",
  },
});

class RecommendRankingAndReactionTags extends React.Component {
  render () {
    const { classes ,item, filterIntentKeywords} = this.props;

    const tags = filterSortIntentTags(item, filterIntentKeywords);

    return (
      <div>
        {(this.props.item.recommend_rank > 0) && (
          <RecommendRanking
            style={{ marginTop: "10px", marginLeft: "-4px" }}
            recommendRank={this.props.item.recommend_rank}
          />
        )}
        {tags.length > 0 && (
          <div className={classes.tagsRoot}>
            <Label
              labelText="投資意欲あり"
              toolTipText="ラベルのキーワードに投資意欲があります"
              labelBgColor="#FD7E00"
            />
            <div className={classes.tagsContainer}>
              {tags.map((tag, index) => (
                <div key={index} className={classes.tag}>
                  <Label
                    labelText={tag}
                    labelColor="#181819"
                    labelBgColor="rgba(26, 101, 255, .05)"
                    fontWeight="normal"
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

RecommendRankingAndReactionTags.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
  filterIntentKeywords: PropTypes.array,
}

PropTypes.defaultValue = {
}

export default withStyles(styles)(RecommendRankingAndReactionTags);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/parts/RecommendRankingAndReactionTags.jsx